export default "__VITE_ASSET__ChHm6H6z__"